import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MasterForm} from '../../../models/master-form';

export interface ClassifierFormData {
  item?: MasterForm;
}

@Component({
  selector: 'app-classifiers-form',
  templateUrl: './classifiers-form.component.html',
  styleUrls: ['./classifiers-form.component.scss']
})
export class ClassifiersFormComponent implements OnInit {

  classifiersForm = this.formBuilder.group({
    code: ['', Validators.required],
    description: ['', Validators.required],
    comment: ['', Validators.required],
    active: [true]
  });

  get codeControl(): FormControl {
    return this.classifiersForm.get('code') as FormControl;
  }
  get descriptionControl(): FormControl {
    return this.classifiersForm.get('description') as FormControl;
  }
  get commentControl(): FormControl {
    return this.classifiersForm.get('comment') as FormControl;
  }
  get activeControl(): FormControl {
    return this.classifiersForm.get('active') as FormControl;
  }

  @Output()
  save: EventEmitter<MasterForm> = new EventEmitter<MasterForm>();


  constructor(@Inject(MAT_DIALOG_DATA) public data: ClassifierFormData,
              private dialogRef: MatDialogRef<ClassifiersFormComponent>,
              private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    if (this.data.item) {
      this.codeControl.setValue(this.data.item.code);
      this.descriptionControl.setValue(this.data.item.description);
      this.commentControl.setValue(this.data.item.comment);
      this.activeControl.setValue(!this.data.item.disabled);
    }
  }

  handleSubmit(): void {
    if (this.classifiersForm.valid) {
      this.save.emit({
        id: this.data.item?.id,
        code: this.codeControl.value,
        description: this.descriptionControl.value,
        comment: this.commentControl.value,
        disabled: !this.activeControl.value
      }, );
    }
  }

}
